<template>
  <div v-if="1">
  <!-- <div v-if="config.gocheckin_feature == 1 || config.appointment_feature == 1 || config.pos_feature == 1"> -->
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/after-login">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Staff</span>
            </li>
        </ul>
    </div>
    <div class="overflow-hidden shadow-md rounded-item">
      <div
        id="staff-list"
        class="rounded-item relative vs-con-loading__container w-full overflow-auto"
      >
        <vs-sidebar
          class="items-no-padding"
          parent="#staff-list"
          :click-not-close="clickNotClose"
          :hidden-background="clickNotClose"
          v-model="active"
          id="staff-list-sidebar"
        >
          <div class="flex justify-between align-center p-6">
            <h3 class="font-bold">Staff</h3>
            <vs-button
              type="filled"
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              class="ml-4 add-staff-btn"
              @click.stop="addNewData"
            ></vs-button>
          </div>

          <div class="staff__profile-search flex p-4 align-center px-6">
            <!-- <div class="relative inline-flex">
              <vs-avatar class="m-0 border-2 border-solid border-white" size="40px" text="abcdef"></vs-avatar>
            </div> -->
            <!-- <vs-input
              icon-no-border
              icon="icon-search"
              @input="searchStaff" @change="searchStaff"
              icon-pack="feather"
              class="w-full rounded-item"
            /> -->
            <div class="con-input-search vs-table--search">
              <input type="text" class="input-search vs-table--search-input py-2 px-7 rounded-item rounded-item-left" id="search-staff" @keyup="searchStaff" placeholder="Search staff"/>
              <i class="vs-icon notranslate icon-scale material-icons null">search</i>
              <!-- <feather-icon icon="SearchIcon" svgClasses="h-4 w-4 stroke-current text-grey" class="block" /> -->
            </div>
            <vs-dropdown
                vs-trigger-click
                class="cursor-pointer item-per-page-dropdown sm:text-xs text-sm"
              >
                <!-- <div
                  class="px-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <feather-icon icon="FilterIcon" svgClasses="h-5 w-5" />
                </div> -->
                <!-- <div
                  class="px-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >

                </div> -->
                <vs-button class="px-3 rounded-item rounded-item-right filter-btn" type="border">
                  <feather-icon icon="FilterIcon" svgClasses="h-5 w-5 filter-icon"/>
                </vs-button>
                <vs-dropdown-menu class="dropdown-filter">
                  <vs-dropdown-item @click="listAll">
                    <span class="sm:text-xs text-sm w-full flex justify-between align-center" :class="{'text-primary': status == 2}">
                      ALL
                      <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="status == 2"/>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="listActive">
                    <span class="sm:text-xs text-sm w-full flex justify-between align-center" :class="{'text-primary': status == 1}">
                      ACTIVE
                      <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="status == 1"/>
                    </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="listInActive">
                    <span class="sm:text-xs text-sm w-full flex justify-between align-center" :class="{'text-primary': status == 0}">
                      INACTIVE
                      <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="status == 0"/>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
          </div>

          <vs-divider class="d-theme-border-grey-light m-0" />
          <!-- <vs-pagination :total="parseInt(staffsData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
          <!-- <VuePerfectScrollbar class="staff-scroll-area pt-4" :settings="settings"> -->
            <!-- ACTIVE STAFFS LIST -->
            <div class="staff-item-list">
              <div class="staff__staffs-list">
                <div class="staff__active-staffs bordered-items" style="background: #f3f3f3">
                  <draggable v-model="dragList" :scroll-sensitivity="250" :force-fallback="true" handle=".move-btn" @end="getOrderList" v-if="dragList && dragList.length > 0">
                    <transition-group>
                      <div
                        class="staff-item-to-drag cursor-pointer"
                        v-for="(staff) in dragList"
                        :key="staff.user_id"
                        @click="updateActiveStaff(staff)"
                      >
                        <staff-item :staffData="staff" :isActive="isActive(staff.user_id)"></staff-item>
                      </div>
                    </transition-group>
                  </draggable>
                </div>
              </div>
            </div>
            <!-- <vs-pagination :total="parseInt(staffsData._meta.pageCount)" v-model="currentPage" @click.native="changePage(currentPage, itemsPerPage)"></vs-pagination> -->
          <!-- </VuePerfectScrollbar> -->
          <!-- <div v-if="staffsData._meta.pageCount">
            <custom-pagination class="custom-pagination" :totalPages="parseInt(staffsData._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
          </div> -->
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <!-- <div class="staff__bg app-fixed-height staff-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 overflow-auto" style="min-width: 888px; background: #fff"> -->
        <div class="staff__bg app-fixed-height staff-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0 overflow-auto" style="min-width: 949px; background: #fff">
          <!-- <staff-content :activeStaffData="activeStaffData" :avatarColor="avatarColor" :servicesList="servicesList" @EditStaff="editStaff"></staff-content> -->
          <transition name="list">
            <staff-content
              v-if="staffsList.length != 0 && !isInConfiguration"
              :activeStaffData="activeStaffData"
              :servicesList="servicesList"
              :serviceData="serviceData"
              :workingHourData="workingHourData"
              :staffServiceData="staffServiceData"
              @EditStaff="editStaff"
              @AddStaffService="addStaffService"
              @DeleteStaffService="deleteStaffService"
              :avatarColor="avatarColor"
              :key="staff_key"
              :currentPage="currentPage"
              :itemsPerPage="itemsPerPage"
              @DeleteStaff="deleteStaff"
              @ChangeStaffStatus="updateStaff"
              :filter="status"
              @EditCommission="editCommission"
              @ChangeStaffSetting="changeStaffSetting"
            ></staff-content>
          </transition>
          <transition name="list">
            <configuration-content :activeStaffData="activeStaffData" v-if="isInConfiguration" @OutConfiguration="isInConfiguration = false" @UpdateStaff="updateActiveStaff" @SaveCommission="editCommissionInfo" :key="edit_commission_key"></configuration-content>
          </transition>
          <div id="staff-content" v-if="staffsList.length == 0 && !isInConfiguration" class="position-relative h-full">
            <div class="translate-center text-lg">No data Available</div>
          </div>
        </div>
      </div>
      <div class="update-add-sidebar">
        <vs-update-staff
          :staffConfig="staffConfig"
          :staffData="activeStaffData"
          @CloseSidebar="closeSidebar"
          @UpdateStaff="updateStaff"
          :key="update_key"
          :currentPage="currentPage"
          :itemsPerPage="itemsPerPage"
          :filter="status"
        ></vs-update-staff>
        <vs-add-staff :addStaffConfig="addStaffConfig" @CloseSidebar="closeSidebar" :staffList="staffsList" :currentPage="currentPage" @AddStaff="addStaff"></vs-add-staff>
        <vs-commission-setting :commissionSettingConfig="commissionSettingConfig" @FinishCommissionSetting="finishCommissionSetting" @SaveCommission="saveCommission"></vs-commission-setting>
      </div>
    </div>
  </div>
  <div v-else>
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar,
    draggable
  },
  // props: {
  //   dataChange: {
  //     type: Object
  //   }
  // },
  data() {
    return {
      staffConfig: { isOpen: false },
      addStaffConfig: { isOpen: false },
      commissionSettingConfig: { isOpen: false },
      // workingHourData: {},
      // serviceData: {},
      // staffServiceData: [],
      active: true,
      // staffsList          : [],
      activeStaff: null,
      activeStaffData: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      clickNotClose: true,
      avatarColor         : '',
      servicesList: [],
      currentPage: 1,
      itemsPerPage: 100,
      abc: 0,
      search: '',
      // filter: 2,
      status: 2,
      items: [
        {
          title: 'Home',
          url: '/',
          icon: "HomeIcon",
        },
        {
          title: 'Staff',
          active: true,
        },
      ],
      staff_key: 0,
      update_key: 0,
      action_type: '',
      isOpenLoading: false,
      page_key: 0,
      loaded_data_num: 0,
      isEmptyList: false,
      dragList: [],
      isInConfiguration: false,
      commissionSetting: {},
      edit_commission_key: 0
    };
  },
  watch: {
  //   dataChange: {
  //     immediate: true,
  //     deep: true,
  //     handler: function () {
  //       // if(this.dataChange) {
  //       //   console.log(this.dataChange.message);
  //       // }
  //       // if(this.dataChange && this.dataChange.message == 'afterInsert') {
  //       if(this.dataChange) {
  //         if(this.dataChange.message.model == 'Employee') {
  //           const obj = {
  //             page: this.currentPage,
  //             "per-page": this.itemsPerPage,
  //             name: this.search,
  //             sort: 'user_id'
  //           }
  //           if(this.status != 2) {
  //             obj.status = this.status;
  //           }
  //           this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(()=> {
  //             if(this.staffsList.length > 0) {
  //               this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
  //             }
  //           })
  //           this.getServiceList();
  //         }
  //       }
  //     },
  //   }
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 4 || this.isEmptyList) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    },
    staffsList: {
      immediate: true,
      deep: true,
      handler() {
        this.dragList = this.staffsList;
        if(this.dragList && this.dragList.length == 1) {
          this.updateActiveStaff(this.dragList[0])
        }
      }
    },

  },
  methods: {
    changeStaffSetting(data){
     this.activeStaffData = data;
     this.staff_key++;
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' staff failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    getOrderList() {
      this.orderedList = [];
      for(let i = 0 ; i < this.dragList.length; i++){
        this.orderedList.push(this.dragList[i].user_id);
      }
      const obj = {
        employees: this.orderedList.length > 0 ? String(this.orderedList) : '',
        page: this.currentPage,
        'per-page': this.itemsPerPage
      }
      this.openLoadingInDiv();
      this.$store.dispatch("staffList/DRAG_STAFF", obj).then(() => {
        this.closeLoading();
      });
    },
    addStaff(staff) {
      this.abc++;
      this.currentPage = staff['page'] ? staff['page'] : 1;
      this.changePage(this.currentPage);
      if(this.config && this.config.pos_feature == 1) {
        this.commissionSettingConfig.isOpen = true;
        this.commissionSetting = staff;
      }
    },
    editCommissionInfo(data){
      this.$store.dispatch("staffList/UPDATE_COMMISION", data).then(() => {
      this.closeLoading();
        const obj = {
          id : data.staff_id,
          commission_type : data.type,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          filter: this.status
        }
        this.$store.dispatch("staffList/CHANGE_STAFF_COMMISSION", obj)
        this.$vs.notify({
          title: "Notification",
          text: "Update Commission Success",
          color: "success",
          position: "top-right"
        });
      })
      .catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Commission Fail",
          color: "danger",
          position: "top-right"
        });
      })
      this.edit_commission_key++;
    },
    saveCommission(data){
      data.staff_id = this.commissionSetting.user_id
      this.$store.dispatch("staffList/UPDATE_COMMISION", data).then(() => {
        this.closeLoading();
        const obj = {
          id : data.staff_id,
          commission_type : data.type,
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          filter: this.status
        }
        this.$store.dispatch("staffList/CHANGE_STAFF_COMMISSION", obj)
        this.$vs.notify({
          title: "Notification",
          text: "Update Commission Success",
          color: "success",
          position: "top-right"
        });
      })
      .catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Commission Fail",
          color: "danger",
          position: "top-right"
        });
      })
      this.commissionSettingConfig.isOpen = false;
    },
    listAll(){
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      const obj={
        page: 1,
        "per-page": this.itemsPerPage,
        sort: 'user_id'
      }
      this.action_type = "Get list";
      this.$store.dispatch('staffList/GET_STAFF_LIST',obj).then(()=> {
        if(this.staffsList.length > 0) {
          this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
        }
        this.currentPage = 1;
        // this.filter = 2;
        this.status = 2;
        this.closeLoading();
        document.getElementById('search-staff').value = '';
        this.search = '';
      })
    },
    listActive(){
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      const obj={
        page: 1,
        "per-page": this.itemsPerPage,
        status: 1,
      }
      this.action_type = "Get list";
      // console.log(obj)
      this.$store.dispatch('staffList/GET_STAFF_LIST',obj).then(() => {
        this.currentPage = 1;
        if(this.staffsList.length > 0) {
          this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
        }
        // this.filter = 1;
        this.status = 1;
        this.closeLoading();
        document.getElementById('search-staff').value = '';
        this.search = '';
      })
    },
    listInActive(){
      this.action_type = "Get list";
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      const obj={
        page: 1,
        "per-page": this.itemsPerPage,
        status:0,
      }
      // console.log(obj)
      this.$store.dispatch('staffList/GET_STAFF_LIST',obj).then(()=> {
        this.currentPage = 1;
        if(this.staffsList.length > 0) {
          this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
        }
        // this.filter = 0;
        this.status = 0;
        this.closeLoading();
        document.getElementById('search-staff').value = '';
        this.search = '';
      })
    },
    searchStaff({target}){
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      // this.$vs.loading({
      //   container: "#staff-list",
      //   scale: 0.8
      // });
      if(this.staffsList.length > 0) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
      }
      this.action_type = "Search";

      this.timer = setTimeout(() => {
        this.search = target.value;
        this.currentPage = 1;
        const obj={
          page: this.currentPage,
          "per-page": this.itemsPerPage,
          "name": target.value,
          sort: 'user_id'
        }
        if(this.status != 2) {
          obj.status = this.status;
        }
        this.$store.dispatch('staffList/GET_STAFF_LIST',obj).then(()=>{
          this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
          // this.$vs.loading.close("#staff-list > .con-vs-loading");
          this.closeLoading();
        });
      }, 500);
      // this.search = target.value;
      // this.currentPage = 1;
      // const obj={
      //   page: this.currentPage,
      //   "per-page": this.itemsPerPage,
      //   "name": target.value,
      //   sort: 'user_id'
      // }
      // if(this.status != 2) {
      //   obj.status = this.status;
      // }
      // this.$store.dispatch('staffList/GET_STAFF_LIST',obj).then(()=>{
      //   if(this.staffsList.length > 0) {
      //     this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
      //   }
      //   // console.log("search")
      //   this.closeLoading();
      // })
    },
    changePage(currentPage) {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
        const obj = {
            page: currentPage,
            "per-page": this.itemsPerPage,
            "name": this.search,
            sort: 'user_id'
            // status: this.status
        }
        if(this.status != 2) {
          obj.status = this.status;
        }
        this.action_type = "Get list";
        this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(()=>{
          if(this.staffsList.length > 0) {
            this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
          }
          // this.currentPage = currentPage;
          // this.page_key++;
          this.closeLoading();
        })

        this.currentPage = currentPage;
          this.page_key++;
    },
    updateActiveStaff(staff) {
      this.loaded_data_num = 2;
      if(staff) {
        this.activeStaff = staff.user_id;
        this.activeStaffData = staff;
        this.staff_key++;
        this.isInConfiguration = false;
      }
    //   const obj = {
    //   id: this.activeStaffData.user_id
    // }

    // this.$store.dispatch("staffList/GET_WORKING_HOUR", obj).then((response) => {

    //   this.workingHourData = response;
    // })
      this.getWorkingHour();
      this.getStaffServiceList();
    },

    getWorkingHour() {
      const obj = {
        id: this.activeStaffData.user_id
      }
      // console.log(obj)
      this.$store.dispatch("staffList/GET_WORKING_HOUR", obj).then(() => {
        this.loaded_data_num++;
      })
      // this.$store.dispatch("staffList/GET_WORKING_HOUR", obj).then((response) => {
      //   this.workingHourData = response;
      // }).catch(error=>console.log(JSON.parse(error)))

    },

    // saveWorkingHour(data) {
    //   // this.$store.dispatch("staffList/UPDATE_WORKING_HOUR", data)
    // },

    getServiceList() {
      this.$store.dispatch("staffList/GET_SERVICE_LIST").then(() => {
        this.loaded_data_num++;
      })
      // this.$store.dispatch("staffList/GET_SERVICE_LIST").then((response) => {
      //   this.serviceData = response;
      // }).catch(error=>console.log(JSON.parse(error)))
    },

    getStaffServiceList() {
      const obj = {
        id: this.activeStaffData.user_id
      }
      this.$store.dispatch("staffList/GET_STAFF_SERVICE_LIST", obj).then(() => {
        this.loaded_data_num++;
      })
      // this.$store.dispatch("staffList/GET_STAFF_SERVICE_LIST", obj).then((response) => {
      //   this.staffServiceData = response;
      // }).catch(error=>{
      //   console.log(JSON.parse(error));
      //   this.staffServiceData = [];
      // })
    },

    addStaffService(service_id) {
      const obj = {
        staff_id: this.activeStaffData.user_id,
        services: service_id
      }
      this.$store.dispatch("staffList/ADD_SERVICE_TO_STAFF", obj)
      // this.$store.dispatch("staffList/ADD_SERVICE_TO_STAFF", obj).then((response) => {
      //   this.getStaffServiceList();
      //   console.log(response);
      // })
    },
    deleteStaff(data) {
      // this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
      data['name'] = this.search;
      this.openLoadingInDiv();
      this.$store.dispatch("staffList/DELETE_STAFF",data).then(() => {
        //  setTimeout(() => {
        //     this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
        // }, 100);
        // console.log(this.staffsData._meta.totalCount)
        if(this.staffsData._meta.totalCount % 10 == 1 && this.currentPage > 1) {
          this.currentPage -= 1;
        }
        this.changePage(this.currentPage);
        // console.log(this.currentPage);
        // this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Delete Staff Success',
          color:'success',
          position:'top-right'})
      })
    },
    deleteStaffService(service_id) {
      const obj = {
        staff_id: this.activeStaffData.user_id,
        services: service_id
      }
      this.$store.dispatch("staffList/REMOVE_SERVICE_FROM_STAFF", obj)
      // this.$store.dispatch("staffList/REMOVE_SERVICE_FROM_STAFF", obj).then((response) => {
      //   this.getStaffServiceList();
      //   // console.log(response);
      // })
    },
    isActive(id) {
      return id == this.activeStaff;
    },
    closeSidebar() {
      this.staffConfig.isOpen = false;
      this.addStaffConfig.isOpen = false;
      document.getElementById("staff-list").click();
    },
    editStaff(data) {
      this.staffConfig.isOpen = true;
      this.activeStaffData = data;
    },
    addNewData() {
      // if (this.config.staff_limit && this.config.staff_limit != 0){
      //   if (this.config.staff_limit <= this.staffsList.length){
      //     this.$vs.dialog({
      //     color: 'danger',
      //     title: `Staff reach limit`,
      //     text: 'Please contact us for more info at: 832-968-6668.',
      //   })
      //   }
      //   else{
      //   this.addStaffConfig.isOpen = true;
      //   }
      // }else{
        this.addStaffConfig.isOpen = true;
      // }
    },
    updateStaff(staff) {
      // console.log(staff);
      this.activeStaffData = staff;
      // this.updateActiveStaff(staff);
      // this.filter = 2;
      // this.status = 2;
      // if(staff.filter) {
      //   this.status = staff.filter;
      // }
      this.staff_key++;
      this.update_key++;
    },
    editCommission() {
      this.isInConfiguration = true;
    },
    finishCommissionSetting(type) {
      console.log('Finish commission setting, type: ' + type);
      this.commissionSettingConfig.isOpen = false;
    }
  },
  computed: {
    staffsList() {
      return this.$store.getters["staffList/staffList"];
    },
    staffsData() {
      return this.$store.getters["staffList/staffData"];
    },
    workingHourData() {
      return this.$store.getters["staffList/workingHours"];
    },
    serviceData() {
      return this.$store.getters["staffList/serviceList"];
    },
    staffServiceData() {
      return this.$store.getters["staffList/staffServiceList"];
    },
    config(){
      return this.$store.getters["auth/config"];
    }
  },
  created() {
    const obj = {
      page: this.currentPage,
      "per-page": this.itemsPerPage,
      sort: 'user_id'
    }
    if(this.status != 2) {
      obj.status = this.status;
    }
    this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(() => {
      if(this.$store.getters["staffList/staffList"].length != 0) {
        this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
      } else {
        this.isEmptyList = true;
      }
      this.loaded_data_num++;
    }).catch(error=>console.log(JSON.parse(error)));

    this.getServiceList();
    this.$store.dispatch('appSetting/GET_BUSINESS_WORK_HOUR')
    this.$store.dispatch('staffList/GET_PERMISSION_LIST')
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/custom/staff/_staff.scss";
</style>
